import { request } from './request'

export function mergeFiles(files, separator, addFileName) {
  const formData = new FormData()
  for (const file of files) {
    formData.append('files', file)
  }
  formData.append('separator', separator || '')
  formData.append('addFileName', addFileName ? 'true' : 'false')
  // 不要手动设置 Content-Type，交给浏览器/axios 自动生成带 boundary 的 multipart/form-data，
  // 硬写 Content-Type 会丢失 boundary，Tomcat 解析时会触发 FileCountLimitExceededException。
  return request.post('/file-merge/merge', formData, { timeout: 60000 })
}
